<div class="tickets-header" *ngIf="!filter">
    <div class="header-content">
        <h1 class="page-title">
            <mat-icon>confirmation_number</mat-icon>
            Tickets
        </h1>

        <div class="navigation-tabs">
            <button
                mat-button
                class="nav-tab"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLink="/tickets"
            >
                <mat-icon>tune</mat-icon>
                <span>Alle</span>
            </button>
            <button
                mat-button
                class="nav-tab"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLink="/tickets/my"
            >
                <mat-icon>person</mat-icon>
                <span>Meine</span>
            </button>
            <button
                mat-button
                class="nav-tab"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLink="/tickets/bookmarked"
            >
                <mat-icon>bookmark</mat-icon>
                <span>Verfolgt</span>
            </button>
            <button
                mat-button
                class="nav-tab"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLink="/tickets/closed"
            >
                <mat-icon>check_circle</mat-icon>
                <span>Erledigt</span>
            </button>
        </div>

        <div class="header-actions">
            <div class="ticket-count-header">
                <span class="count-number">{{ shownTickets.length }}</span>
                <span class="count-label">Tickets</span>
            </div>

            <button mat-fab color="primary" class="add-ticket-fab" (click)="newTicket()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="filters-section" *ngIf="!filter">
    <div class="filters-content">
        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Mitarbeiter</mat-label>
            <mat-select [(ngModel)]="maId" (selectionChange)="filterTickets()">
                <mat-option value="">Alle Mitarbeiter</mat-option>
                <mat-option *ngFor="let user of glo.activeTicketSupportUsers" [value]="user.uid">
                    {{ user.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Priorität</mat-label>
            <mat-select [(ngModel)]="colorFilter" (selectionChange)="filterTickets()">
                <mat-option value="">Alle Prioritäten</mat-option>
                <mat-option value="red">
                    <div class="priority-option">
                        <div class="priority-dot red"></div>
                        Hoch
                    </div>
                </mat-option>
                <mat-option value="orange">
                    <div class="priority-option">
                        <div class="priority-dot orange"></div>
                        Mittel
                    </div>
                </mat-option>
                <mat-option value="blue">
                    <div class="priority-option">
                        <div class="priority-dot blue"></div>
                        Normal
                    </div>
                </mat-option>
                <mat-option value="green">
                    <div class="priority-option">
                        <div class="priority-dot green"></div>
                        Niedrig
                    </div>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Typ</mat-label>
            <mat-select [(ngModel)]="showDevTickets" (selectionChange)="filterTickets()">
                <mat-option value="">Alle Tickets</mat-option>
                <mat-option value="hide">Standard Tickets</mat-option>
                <mat-option value="only">Entwicklertickets</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="tickets-list-container">
    <div class="section-header" *ngIf="filter === 'my'">
        <h2>Meine offenen Tickets</h2>
    </div>

    <div class="tickets-list">
        <cdk-virtual-scroll-viewport class="tickets-viewport" [itemSize]="85">
            <app-ticket-short *cdkVirtualFor="let ticket of shownTickets" [ticket]="ticket" class="ticket-item">
            </app-ticket-short>
        </cdk-virtual-scroll-viewport>
    </div>
</div>
